module.exports = __webpack_public_path__ + "static/media/undraw_blank_canvas_3rbb.35e81baf.svg";